export default __webpack_public_path__ + "static/media/data-missing-icon.1ba3c904.svg";